import Web3 from 'web3'
import BigNumber from 'bignumber.js'
import { getAddress } from '@ethersproject/address'
import ERC20Json from 'lottery/abi/ERC20.json'
import LotteryAbi from 'lottery/abi/LotteryPoolV1.json'

import ropstenTokenList from 'lottery/ropsten.json'
import kovanTokenList from 'lottery/kovan.json'
import allTokensList from 'lottery/uniswap_all_tokens_list.json'

const ERC20Abi = ERC20Json.abi

// const networks = {
//   1: 'mainnet',
//   3: 'ropsten',
//   42: 'kovan',
// }

const networkTokenLists = {
  1: ropstenTokenList,
  3: ropstenTokenList,
  42: kovanTokenList,
}

export const allTokens = allTokensList

export const allTokensDict = {}
for (let t of allTokens.tokens) {
  allTokensDict[t.address.toLowerCase()] = t
}

export const env = process.env.REACT_APP_ENV
export const tokenList =
  networkTokenLists[Number(process.env.REACT_APP_CHAIN_ID)]

export const tokenDict = {}
for (let t of tokenList) {
  tokenDict[t.address.toLowerCase()] = t
}

export const poolsAddress = process.env.REACT_APP_POOLS_ADDRESS
export const tokenAddress = process.env.REACT_APP_TOKEN_ADDRESS

export const getUbetToken = (provider, address) => {
  const web3 = new Web3(provider)
  const contract = new web3.eth.Contract(ERC20Abi, address)
  return contract
}

export const weiToEth = (balance, decimals = 18) => {
  const displayBalance = balance.dividedBy(new BigNumber(10).pow(decimals))
  return displayBalance.toNumber()
}

export const ubetToEth = weiToEth

export const getERC20Token = (provider, address) => {
  const web3 = new Web3(provider)
  const contract = new web3.eth.Contract(ERC20Abi, address)
  return contract
}

export const getPoolContract = (provider, address = poolsAddress) => {
  const web3 = new Web3(provider)
  const contract = new web3.eth.Contract(LotteryAbi, address)
  return contract
}

export const getBalance = async (provider, tokenAddress, userAddress) => {
  const lpContract = getERC20Token(provider, tokenAddress)
  try {
    const balance = await lpContract.methods.balanceOf(userAddress).call()
    return balance
  } catch (e) {
    return '0'
  }
}

const ENS_NAME_REGEX = /^(([a-zA-Z0-9]+\.)+)eth(\/.*)?$/

export const parseENSAddress = (ensAddress) => {
  const match = ensAddress.match(ENS_NAME_REGEX)
  if (!match) return undefined
  return { ensName: `${match[1].toLowerCase()}eth`, ensPath: match[3] }
}

export const isAddress = (value) => {
  try {
    return getAddress(value)
  } catch (err) {
    return false
  }
}
export const poolsPagePage = parseInt(process.env.REACT_APP_POOL_PER_PAGE)
export const getTokenURL = 'https://app.bounce.finance/fixed-swap/5080'
export const viewTranscationURL =
  parseInt(process.env.REACT_APP_CHAIN_ID) === 42
    ? 'https://kovan.etherscan.io/tx/'
    : 'https://etherscan.io/tx/'
